import { stripNamespace } from '../nbt/blockLabel';
import type { StructureModel } from '../nbt/types';

/**
 * ガイドが指すブロックID（namespaceなし）に当てはまる、モデルのpalette state番号を集める。
 * Java版のpaletteは`minecraft:`付き、Bedrock由来はnamespaceなしに正規化済みなので、
 * 両側のnamespaceを剥がして比べる。向きや状態が違うだけのpalette項目もすべて含める。
 */
export function statesForBlockIds(model: StructureModel, ids: readonly string[]): Set<number> {
  const wanted = new Set(ids.map((id) => stripNamespace(id)));
  const states = new Set<number>();
  model.palette.forEach((entry, state) => {
    if (wanted.has(stripNamespace(entry.name))) states.add(state);
  });
  return states;
}
